import React, { Suspense, useEffect, useRef } from "react";
import { lazyComReload } from "utils/lazyComReload";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import JwtAuthService from "services/JwtAuthService";
import MenuService from "services/MenuService";
import useChatNotifications from "hooks/useChatNotifications";
import useChatTabTitle from "hooks/useChatTabTitle";

// Isola a subscription do contador de não lidas (useChatTabTitle assina
// state.menu.chat). Mantido em AppViews, qualquer mudança no contador
// re-renderizava toda a árvore de rotas.
const ChatBootstrap = () => {
	useChatNotifications();
	useChatTabTitle();
	return null;
};

export const AppViews = () => {
	let intervalId = useRef(null);

	const populateMenu = async () => {
		try {
			if (JwtAuthService.isLogged()) {
				await MenuService.populateMenuData();
			}
		} catch (e) {}

		intervalId.current = setInterval(async () => {
			if (JwtAuthService.isLogged()) {
				try {
					await MenuService.populateMenuData();
				} catch (e) {
					console.error(e);
				}
			}
		}, 300000); // 5 minutos
	};

	useEffect(() => {
		populateMenu();

		return () => {
			clearInterval(intervalId.current);
		};
	}, []);

	return (
		<Suspense fallback={<Loading cover="content" />}>
			<ChatBootstrap />
			<Switch>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard-profissional`}
					component={lazyComReload(() => import(`./dashboard-profissional`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/jornada`}
					component={lazyComReload(() => import(`./jornada`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard`}
					component={lazyComReload(() => import(`./dashboard`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/crm`}
					component={lazyComReload(() => import(`./crm`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard-admin`}
					component={lazyComReload(() => import(`./dashboard-admin`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard-financeiro`}
					component={lazyComReload(() => import(`./dashboard-financeiro`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dashboard-trafego`}
					component={lazyComReload(() => import(`./dashboard-trafego`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/chat`}
					component={lazyComReload(() => import(`./chat`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/comunidades`}
					component={lazyComReload(() => import(`./comunidades`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/comunidade`}
					component={lazyComReload(() => import(`./comunidade`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/inicio-rapido`}
					component={lazyComReload(() => import(`./inicio-rapido`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/roadmap`}
					component={lazyComReload(() => import(`./roadmap`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dados-conta`}
					component={lazyComReload(() => import(`./dados-conta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/suporte`}
					component={lazyComReload(() => import(`./suporte`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/ajuda`}
					component={lazyComReload(() => import(`./ajuda`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/indicacoes`}
					component={lazyComReload(() => import(`./indicacoes`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-usuarios`}
					component={lazyComReload(() => import(`./lista-usuarios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/usuario/:id`}
					component={lazyComReload(() => import(`./usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/usuario`}
					component={lazyComReload(() => import(`./usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-grupos-usuario`}
					component={lazyComReload(() => import(`./lista-grupos-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-usuario/:id`}
					component={lazyComReload(() => import(`./grupo-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-usuario`}
					component={lazyComReload(() => import(`./grupo-usuario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-alimento`}
					component={lazyComReload(() => import(`./lista-alimento`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/alimento/:id`}
					component={lazyComReload(() => import(`./alimento`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/alimento`}
					component={lazyComReload(() => import(`./alimento`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-refeicao`}
					exact
					component={lazyComReload(() => import(`./lista-refeicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/refeicao/:id`}
					component={lazyComReload(() => import(`./refeicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/refeicao`}
					exact
					component={lazyComReload(() => import(`./refeicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-tabela-substituicao`}
					component={lazyComReload(() =>
						import(`./lista-tabela-substituicao`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/tabela-substituicao/:id`}
					component={lazyComReload(() => import(`./tabela-substituicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/tabela-substituicao`}
					component={lazyComReload(() => import(`./tabela-substituicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-ficha-dieta`}
					component={lazyComReload(() => import(`./lista-ficha-dieta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/ficha-dieta/:id`}
					component={lazyComReload(() => import(`./ficha-dieta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/ficha-dieta`}
					component={lazyComReload(() => import(`./ficha-dieta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dieta-unificada/:id`}
					component={lazyComReload(() => import(`./dieta-unificada`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dieta-unificada`}
					component={lazyComReload(() => import(`./dieta-unificada`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dieta-unificada-precadastrada/:id`}
					component={lazyComReload(() =>
						import(`./dieta-unificada-precadastrada`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/dieta-unificada-precadastrada`}
					component={lazyComReload(() =>
						import(`./dieta-unificada-precadastrada`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-tecnica-exercicio`}
					component={lazyComReload(() => import(`./lista-tecnica-exercicio`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/tecnica-exercicio/:id`}
					component={lazyComReload(() => import(`./tecnica-exercicio`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/tecnica-exercicio`}
					component={lazyComReload(() => import(`./tecnica-exercicio`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-exercicio`}
					component={lazyComReload(() => import(`./lista-exercicio`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/exercicio/:id`}
					component={lazyComReload(() => import(`./exercicio`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/exercicio`}
					component={lazyComReload(() => import(`./exercicio`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-ficha-treino`}
					component={lazyComReload(() => import(`./lista-ficha-treino`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/ficha-treino/:id`}
					component={lazyComReload(() => import(`./ficha-treino`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/ficha-treino`}
					component={lazyComReload(() => import(`./ficha-treino`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-alunos`}
					component={lazyComReload(() => import(`./lista-alunos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/observacoes-gerais/:tipo`}
					component={lazyComReload(() => import(`./observacoes-gerais`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/detalhes-aluno/:id`}
					component={lazyComReload(() => import(`./detalhes-aluno`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-questionario-dinamico`}
					component={lazyComReload(() =>
						import(`./lista-questionario-dinamico`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/questionario-dinamico/:id`}
					component={lazyComReload(() => import(`./questionario-dinamico`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/questionario-dinamico`}
					component={lazyComReload(() => import(`./questionario-dinamico`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/configuracao-app/financeiro`}
					component={lazyComReload(() =>
						import(`./configuracao-app-financeiro`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/configuracao-app`}
					component={lazyComReload(() => import(`./configuracao-app`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-notificacoes`}
					component={lazyComReload(() => import(`./lista-notificacoes`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/assinatura`}
					component={lazyComReload(() => import(`./assinatura`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/creditos`}
					component={lazyComReload(() => import(`./creditos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/conta-bloqueada`}
					component={lazyComReload(() => import(`./conta-bloqueada`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-cupom`}
					component={lazyComReload(() => import(`./lista-cupom`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/cupom-usos/:id`}
					component={lazyComReload(() => import(`./cupom-usos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/cupom/:id`}
					component={lazyComReload(() => import(`./cupom`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/cupom`}
					component={lazyComReload(() => import(`./cupom`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-oferta`}
					component={lazyComReload(() => import(`./lista-oferta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/oferta/:id`}
					component={lazyComReload(() => import(`./oferta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/oferta`}
					component={lazyComReload(() => import(`./oferta`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/ranking-gamificacao`}
					component={lazyComReload(() => import(`./ranking-gamificacao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/competicao/:id`}
					component={lazyComReload(() => import(`./competicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/competicao`}
					component={lazyComReload(() => import(`./competicao`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-plano-contratual`}
					component={lazyComReload(() => import(`./lista-plano-contratual`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/plano-contratual/:id`}
					component={lazyComReload(() => import(`./plano-contratual`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/plano-contratual`}
					component={lazyComReload(() => import(`./plano-contratual`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-grupamentos-musculares`}
					component={lazyComReload(() =>
						import(`./lista-grupamentos-musculares`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupamento-muscular/:id`}
					component={lazyComReload(() => import(`./grupamento-muscular`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupamento-muscular`}
					component={lazyComReload(() => import(`./grupamento-muscular`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-treino-precadastrado`}
					component={lazyComReload(() =>
						import(`./lista-treino-precadastrado`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/treino-precadastrado/:id`}
					component={lazyComReload(() => import(`./treino-precadastrado`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/treino-precadastrado`}
					component={lazyComReload(() => import(`./treino-precadastrado`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-material`}
					component={lazyComReload(() => import(`./lista-material`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/material/:id`}
					component={lazyComReload(() => import(`./material`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/material`}
					component={lazyComReload(() => import(`./material`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-ficha-dieta-precadastrada`}
					component={lazyComReload(() =>
						import(`./lista-ficha-dieta-precadastrada`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/ficha-dieta-precadastrada/:id`}
					component={lazyComReload(() =>
						import(`./ficha-dieta-precadastrada`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/ficha-dieta-precadastrada`}
					component={lazyComReload(() =>
						import(`./ficha-dieta-precadastrada`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-grupos-funcionario`}
					component={lazyComReload(() => import(`./lista-grupos-funcionario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-funcionario/:id`}
					component={lazyComReload(() => import(`./grupo-funcionario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/grupo-funcionario`}
					component={lazyComReload(() => import(`./grupo-funcionario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-funcionarios`}
					component={lazyComReload(() => import(`./lista-funcionarios`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/funcionario/:id`}
					component={lazyComReload(() => import(`./funcionario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/funcionario`}
					component={lazyComReload(() => import(`./funcionario`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-audit-logs`}
					component={lazyComReload(() => import(`./lista-audit-logs`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-activity-logs`}
					component={lazyComReload(() => import(`./lista-activity-logs`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-log-erro-app`}
					component={lazyComReload(() => import(`./lista-log-erro-app`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/log-erro-app/:id`}
					component={lazyComReload(() => import(`./log-erro-app`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/notificacoes-personalizadas`}
					component={lazyComReload(() =>
						import(`./notificacoes-personalizadas`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/notificacao-personalizada`}
					component={lazyComReload(() =>
						import(`./notificacao-personalizada`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/aulas`}
					component={lazyComReload(() => import(`./aulas`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-modulos`}
					component={lazyComReload(() => import(`./lista-modulos`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/modulo/:id`}
					component={lazyComReload(() => import(`./modulo`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/modulo`}
					component={lazyComReload(() => import(`./modulo`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/lista-planos-profissional`}
					component={lazyComReload(() =>
						import(`./lista-planos-profissional`),
					)}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/plano-profissional/:id`}
					component={lazyComReload(() => import(`./plano-profissional`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/plano-profissional`}
					component={lazyComReload(() => import(`./plano-profissional`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/whatsapp-chat`}
					component={lazyComReload(() => import(`./whatsapp-chat`))}
				/>
				<Route
					path={`${APP_PREFIX_PATH}/quiz-profissional`}
					component={lazyComReload(() => import(`./quiz-profissional-page`))}
				/>
				<Redirect
					from={`${APP_PREFIX_PATH}`}
					to={`${APP_PREFIX_PATH}/dashboard-profissional`}
				/>
			</Switch>
		</Suspense>
	);
};

export default React.memo(AppViews);
